export default __webpack_public_path__ + "static/media/case-studies.22759c97.svg";